import {cloneWithProps} from '../helpers/react-helpers'
import type {ChangeEventHandler, ReactElement, ReactNode} from 'react'
import type {RadioButtonProps} from "./RadioButton"
import {useUuid} from '../helpers/react-hooks'
import {AioInlineLabel} from './aio-inputs/AioLabel'
import css from './aio-inputs/aio.less'
// TODO: drop support for valueLink
// TODO: Only allow RadioButtons as children


export interface RadioGroupProps {
    children: Array<ReactElement<RadioButtonProps> | false | null>
    name?: string
    value: string | number
    onChange?: ChangeEventHandler<HTMLInputElement>
    width?: string | number
    testId?: string
    label?: ReactNode
    required?: boolean
    white?: boolean
}

export default function RadioGroup({children, name, value, onChange, width, testId, required, label, white}: RadioGroupProps) {
    name = useUuid(name)
    return (
        <div className={css.wrapper}>
            {!label ? null : <AioInlineLabel required={required}>{label}</AioInlineLabel>}
            <div className={`radio-horizontal radio-menu ${value ? 'not-empty' : 'empty'}${white ? ' radio-white' : ''}`} style={{width}}>
                {cloneWithProps(children, (btn: ReactElement<RadioButtonProps>) => {
                    const btnProps: RadioButtonProps = {name}
                    const checked = btn.props.value == value
                    if(onChange != null) {
                        btnProps.onChange = onChange
                        btnProps.checked = checked
                    } else {
                        btnProps.defaultChecked = checked
                    }
                    if(testId && !btn.props.testId) {
                        btnProps.testId = `${testId}-${btn.props.value}`
                    }
                    return btnProps
                })}
            </div>
        </div>
    )
}
